import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type RealtimeStatus = 'idle' | 'connecting' | 'connected' | 'reconnecting' | 'disconnected' | 'error';

interface RealtimeState {
    status: RealtimeStatus;
    connected: boolean;
    reconnecting: boolean;
    lastError: string | null;
    lastConnectedAt: string | null;
    lastDisconnectedAt: string | null;
}

const initialState: RealtimeState = {
    status: 'idle',
    connected: false,
    reconnecting: false,
    lastError: null,
    lastConnectedAt: null,
    lastDisconnectedAt: null,
};

const realtimeSlice = createSlice({
    name: 'realtime',
    initialState,
    reducers: {
        setStatus(state, action: PayloadAction<RealtimeStatus>) {
            state.status = action.payload;
            state.connected = action.payload === 'connected';
            state.reconnecting = action.payload === 'reconnecting' || action.payload === 'connecting';
            if (action.payload === 'connected') {
                state.lastConnectedAt = new Date().toISOString();
                state.lastError = null;
            }
            if (action.payload === 'disconnected') {
                state.lastDisconnectedAt = new Date().toISOString();
            }
        },
        setError(state, action: PayloadAction<string | null>) {
            state.lastError = action.payload;
            if (action.payload) state.status = 'error';
        },
        resetRealtime(state) {
            state.status = 'idle';
            state.connected = false;
            state.reconnecting = false;
            state.lastError = null;
        },
    },
});

export const { setStatus, setError, resetRealtime } = realtimeSlice.actions;
export default realtimeSlice.reducer;
